export * from './adapter';
export type { Auth0ClientAdapter } from './Auth0ClientAdapter';
export type { NativeAuthClientAdapter } from './NativeAuthClientAdapter';
export * as Auth0SpaJs from '@auth0/auth0-spa-js';
